import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { sanitiseError } from '@data-terminal/data-access/error/error-parser';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root',
})
export class ErrorDisplayService {
    readonly #snackBar = inject(MatSnackBar);
    readonly #translateService = inject(TranslateService);

    private readonly snackbarDuration = 10000;

    public displayErrorMessage(error: HttpErrorResponse): void {
        const sanitised = sanitiseError(error);
        this.#snackBar.open(
            `${this.#translateService.instant('*.error')}: ${sanitised.message}`,
            this.#translateService.instant('*.action.close'),
            {
                duration: this.snackbarDuration,
                panelClass: 'hdmui-error',
            }
        );
    }
}
